<template>
   
   <div class="ms-nested-card ms-nested-card--deep">
      <div class="ms-nested-header ms-nested-header--green">
         <div class="ms-nested-header__left">
            <span class="ms-nested-title ms-nested-title--green">
               <i class="fas fa-tags"></i> Subcategories
            </span>
         </div>
         <div class="ms-nested-header__right">
            <div class="ms-nested-pagination ms-nested-pagination--green">
               <button @click="previousPage()" :disabled="pagination.page === 1" class="ms-n-page-btn ms-n-page-btn--green">
                  <i class="fa fa-chevron-left"></i>
               </button>
               <span class="ms-n-page-label ms-n-page-label--green">
                  <strong>{{ paginationLabel }}</strong> of {{ pagination.totalItems }}
               </span>
               <button @click="nextPage()"
                  :disabled="pagination.page === pagination.totalPages || pagination.totalItems === 0"
                  class="ms-n-page-btn ms-n-page-btn--green">
                  <i class="fa fa-chevron-right"></i>
               </button>
            </div>
             <button v-if="$store.getters['auth/isGlobalSuperAdmin']" type="button" class="ms-btn ms-btn--green"
                data-bs-toggle="modal" data-bs-target="#subcategoryForm" 
                @click="onButtonClick('create', items.id)">
                <i class="fas fa-plus"></i> Create Subcategory
             </button>
         </div>
      </div>

      <table class="ms-nested-table">
          <thead>
             <tr>
                <th v-for="header in headers" :key="header.value">{{ header.text }}</th>
                <th v-if="$store.getters['auth/isGlobalSuperAdmin']" class="ms-th-action">Action</th>
             </tr>
          </thead>

         <tbody v-if="pagination.totalItems <= 0">
             <tr>
                <td :colspan="$store.getters['auth/isGlobalSuperAdmin'] ? 2 : 1" class="ms-nested-empty">No subcategories found.</td>
             </tr>
         </tbody>

         <tbody v-for="subcategory in subcategories" :key="subcategory.id">
            <tr class="ms-nested-row">
               <td class="ms-nested-cell-name">
                  <span class="ms-sub-dot"></span>
                  {{ subcategory.display_name }}
                  <template v-if="items.name === 'Industry' || items.display_name === 'Industry'">
                     <span v-if="subcategory.is_disclosure_industry" class="ms-pill-badge ms-pill-badge--disclosure ms-2">Disclosure Industry</span>
                     <span v-else class="ms-pill-badge ms-pill-badge--non-disclosure ms-2">Non-Disclosure Industry</span>
                  </template>
               </td>
                <td v-if="$store.getters['auth/isGlobalSuperAdmin']" class="ms-actions" colspan="2">
                   <button type="button" class="ms-action-btn ms-action-btn--edit" data-bs-toggle="modal" data-bs-target="#subcategoryForm" 
                      @click="onButtonClick('edit',subcategory.id)" title="Edit Subcategory">
                      <i class="fa fa-pen"></i>
                   </button>

                   <span v-if="subcategory.is_used" title="Cannot delete subcategory currently being used.">
                      <button type="button" class="ms-action-btn ms-action-btn--delete ms-action-btn--disabled"
                         @click="onButtonClick('delete',subcategory.id)" :disabled="subcategory.is_used">
                         <i class="fa fa-xmark"></i>
                      </button>
                   </span>
                   <span v-else>
                      <button type="button" class="ms-action-btn ms-action-btn--delete"
                         @click="onButtonClick('delete',subcategory.id)" :disabled="subcategory.is_used">
                         <i class="fa fa-xmark"></i>
                      </button>
                   </span>
                </td>
            </tr>
         </tbody>
      </table>
   </div>

</template>

<script>
export default ({

   props: {
      items: {
         type: Object,
         required: true,
      },

      collapsed: {
         type: Boolean,
      }
      
   },

   data(){
      return{
         headers: [
            { text: "Subcategory Name", value: "SubcategoryName" },
         ],
         groups: [],
         categories: [],
         subcategories: [],
         pagination: {
            pageSize: 10,
            page: 1,
            totalItems: 0,
            totalPages: 1,
         },
      }
   },

   created() {
      this.init()
   },

   computed: {

      itemList(){
         return this.items
      },

      paginationLabel() {
         var start =  Math.min((this.pagination.page - 1) * this.pagination.pageSize + 1, this.pagination.totalItems);
         var end = Math.min((this.pagination.page * this.pagination.pageSize), this.pagination.totalItems)
         
         return start + " - " + end
      },

      currentPage() {
         return this.pagination.page
      },

      isCollapsed(){
         return this.mainRowCollapsed || this.collapsed
      },

   },

   watch: {

      itemList(){
         this.init()
      },

      currentPage() {
         this.getSubcategoriesList(this.items.id)
      },

      isCollapsed(){
         this.pagination.page = 1
         this.init()
      },

   },

   methods: {

      init(){
         if(this.pagination.page > 1) {
            this.getSubcategoriesList(this.items.id)
         } else {
            this.subcategories = this.items.subcategories
            this.pagination.totalItems = this.items.total_subcategory
            this.pagination.totalPages = Math.ceil(this.pagination.totalItems / this.pagination.pageSize)
         }
         
      },

      onButtonClick(action, id){
         this.$emit('onButtonClick', action, id,)
      },

      previousPage(){
         this.pagination.page > 1 ? this.pagination.page -= 1 : ''
      },

      nextPage() {
         this.pagination.totalPages > this.pagination.page ? this.pagination.page += 1 : ''
      },

      async getSubcategoriesList(categoryId){

         await this.$axios.get("/subcategories?categoryId="+categoryId+"&pageSize="+this.pagination.pageSize+"&page="+this.pagination.page)
         .then((response) => {
            this.subcategories = response.data.subcategories
            this.pagination.totalItems = response.data.total_items
            this.pagination.totalPages = Math.ceil(this.pagination.totalItems / this.pagination.pageSize)
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
      },
      
   }

})
</script>

<style scoped>
.ms-nested-card--deep {
   border-color: #d1fae5;
}

.ms-nested-header--green {
   background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
   border-bottom-color: #a7f3d0;
}

.ms-nested-title--green {
   color: #065f46;
}

.ms-nested-pagination--green {
   border-color: #a7f3d0;
}

.ms-n-page-btn--green {
   color: #059669;
}

.ms-n-page-btn--green:hover:not(:disabled) {
   background: rgba(16, 185, 129, 0.12);
}

.ms-n-page-btn--green:disabled {
   color: #86efac;
}

.ms-n-page-label--green {
   color: #065f46;
}

.ms-n-page-label--green strong {
   color: #064e3b;
}

.ms-btn--green {
   background: linear-gradient(135deg, #10b981, #34d399);
   color: #fff;
   box-shadow: 0 2px 6px rgba(16, 185, 129, 0.3);
}

.ms-btn--green:hover {
   background: linear-gradient(135deg, #059669, #10b981);
   box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
   transform: translateY(-1px);
}

/* ── Shared styles from parent Category ── */
.ms-nested-card {
   background: #fff;
   border: 1.5px solid #e2e8f0;
   border-radius: 12px;
   margin: 12px 0;
   overflow: hidden;
}

.ms-nested-header {
   display: flex;
   align-items: center;
   justify-content: space-between;
   flex-wrap: wrap;
   gap: 10px;
   padding: 12px 16px;
   border-bottom: 1px solid #e2e8f0;
}

.ms-nested-title {
   font-weight: 700;
   font-size: 0.82rem;
   text-transform: uppercase;
   letter-spacing: 0.5px;
}

.ms-nested-title i {
   margin-right: 6px;
}

.ms-nested-header__right {
   display: flex;
   align-items: center;
   gap: 12px;
}

.ms-nested-pagination {
   display: inline-flex;
   align-items: center;
   border: 1.5px solid #e2e8f0;
   border-radius: 8px;
   background: rgba(255, 255, 255, 0.7);
}

.ms-n-page-btn {
   background: transparent;
   border: none;
   cursor: pointer;
   font-size: 0.75rem;
   padding: 5px 10px;
   transition: background-color 0.15s;
}

.ms-n-page-btn:disabled {
   cursor: not-allowed;
}

.ms-n-page-label {
   font-size: 0.78rem;
   font-weight: 500;
   padding: 0 4px;
   white-space: nowrap;
}

.ms-btn {
   padding: 7px 16px;
   border-radius: 8px;
   font-size: 0.8rem;
   font-weight: 600;
   cursor: pointer;
   display: inline-flex;
   align-items: center;
   gap: 5px;
   transition: all 0.2s ease;
   border: none;
}

.ms-nested-table {
   width: 100%;
   border-collapse: collapse;
}

.ms-nested-table thead tr {
   background: #f8fafc;
}

.ms-nested-table th {
   padding: 10px 16px;
   text-align: left;
   font-size: 0.72rem;
   font-weight: 700;
   color: #64748b;
   text-transform: uppercase;
   letter-spacing: 0.5px;
   border-bottom: 1px solid #e2e8f0;
}

.ms-th-action {
   text-align: right;
}

.ms-nested-table td {
   padding: 11px 16px;
   font-size: 0.85rem;
   color: #334155;
   border-bottom: 1px solid #f1f5f9;
   vertical-align: middle;
}

.ms-nested-row:hover {
   background: #f0fdf4;
}

.ms-nested-cell-name {
   display: flex;
   align-items: center;
   gap: 8px;
   font-weight: 500;
}

.ms-sub-dot {
   width: 6px;
   height: 6px;
   border-radius: 50%;
   background: #10b981;
   flex-shrink: 0;
}

.ms-nested-empty {
   text-align: center;
   padding: 24px 16px !important;
   color: #94a3b8;
   font-style: italic;
}

.ms-actions {
   text-align: right;
   white-space: nowrap;
}

.ms-action-btn {
   width: 32px;
   height: 32px;
   border-radius: 8px;
   border: none;
   cursor: pointer;
   font-size: 0.78rem;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   margin-left: 4px;
   transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.ms-action-btn:hover {
   transform: translateY(-1px);
   box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
}

.ms-action-btn--edit {
   background: #e6f7fa;
   color: #00A0C1;
}

.ms-action-btn--edit:hover {
   background: #00A0C1;
   color: #fff;
}

.ms-action-btn--delete {
   background: #fef2f2;
   color: #dc2626;
}

.ms-action-btn--delete:hover {
   background: #dc2626;
   color: #fff;
}

.ms-action-btn--disabled {
   opacity: 0.4;
   cursor: not-allowed;
}

.ms-action-btn--disabled:hover {
   transform: none;
   box-shadow: none;
   background: #fef2f2;
   color: #dc2626;
}

/* ── Industry Pill Badges ── */
.ms-pill-badge {
   display: inline-flex;
   align-items: center;
   font-size: 0.72rem;
   font-weight: 600;
   padding: 2.5px 10px;
   border-radius: 999px;
   line-height: 1.25;
   letter-spacing: 0.01em;
   white-space: nowrap;
   transition: all 0.15s ease;
}

.ms-pill-badge--disclosure {
   background-color: #fef3c7;
   color: #b45309;
   border: 1px solid #fde68a;
}

.ms-pill-badge--non-disclosure {
   background-color: #f8fafc;
   color: #64748b;
   border: 1px solid #e2e8f0;
   font-weight: 500;
}
</style>
